<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="propertyProfiles" [lazy]="true" (onLazyLoad)="loadLazy($event, false)" dataKey="propertyProfileId"
  selectionMode="single" [(selection)]="propertyProfile" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Off Boardings</h1>
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Property Profile +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}">Tags</th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ShortTermRentalVO.propertyCode', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ownerProfileVOList.lastName', 'in')"></th>

      <th>
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="realEstateStatuses" appendTo="body"
          (onChange)="pt.filter($event.value, 'realEstateStatus', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ambassadorUserVO.lastName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'trnsOutReason', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'trnsOutNewMgrName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'trnsOutReasonDesc', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"><app-tag-join-filter-select [tagSource]="60" (getFilteredTags)="getFilteredTags($event)"></app-tag-join-filter-select></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-propertyProfile>
    <tr [pSelectableRow]="propertyProfile">
      <td>{{propertyProfile?.propertyCode}}</td>
      <td>{{propertyProfile?.ownerProfileVOList[0]?.lastName}}</td>
      <td>{{getStatusName(propertyProfile)}}</td>
      <td>{{propertyProfile?.ambassadorLastName}}</td>
      <td>{{propertyProfile?.trnsOutNoticeDate | date}}</td>
      <td>{{propertyProfile?.trnsOutReason}}</td>
      <td>{{propertyProfile?.trnsOutNewMgrName}}</td>
      <td>{{propertyProfile?.trnsOutReasonDesc}}</td>
      <td>{{propertyProfile?.trnsOutEffectiveDate | date}}</td>
      <app-tag-join-list-select [tagSource]="60" [tagSourceId]="propertyProfile.propertyProfileId" tagType="4"></app-tag-join-list-select>
      <td><span style="float:none">
        <a>
          <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(propertyProfile)">edit</mat-icon>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>